import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import ShipmentHistoryTable from './components/ShipmentHistoryTable';

const ShipmentHistory = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h5 className="page-title">Shipping / Shipment History</h5>
      </Col>
    </Row>
    <Row>
      <ShipmentHistoryTable />
    </Row>
  </Container>
);

export default ShipmentHistory;
